import { Wrench } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface Props {
  needsService: boolean | null | undefined;
  reason: string | null | undefined;
  className?: string;
}

/**
 * Shared "Needs Service" chip for yard list views. Renders nothing when
 * the trailer isn't flagged. Tooltip shows the reported issue (or a
 * fallback when no reason was captured at check-in).
 */
export function NeedsServiceChip({ needsService, reason, className }: Props) {
  if (!needsService) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="destructive"
          className={`gap-1 px-1.5 py-0 h-5 text-[10px] font-medium ${className ?? ""}`}
        >
          <Wrench className="h-3 w-3" />
          Service
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        <p className="font-medium mb-0.5">Needs Service</p>
        <p className="text-xs whitespace-pre-wrap">
          {reason?.trim() || "No reason provided"}
        </p>
      </TooltipContent>
    </Tooltip>
  );
}